import { RolesAndPrivilegesControllerApi } from "../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../utils/utils";

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useRoleArchive = () =>
  useMutationWithLoading(async (params: { roleId: number; status: boolean }) =>
    new RolesAndPrivilegesControllerApi(
      getConfigObject()
    ).updateRoleArchiveStatus(params?.roleId, params?.status, getXtenantId())
  );
